// Check if the page has fully loaded
document.addEventListener("DOMContentLoaded", function() {
  
  // Get the query parameter value from the URL
  function getQueryParam(param) {
    const urlSearchParams = new URLSearchParams(window.location.search);
    return urlSearchParams.get(param);
  }

  // Scroll to the anchor point
  function scrollToAnchor(anchor) {
    const element = document.getElementById(anchor);
    if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
    }
  }

  // Check if there's a query parameter named 'scrollTo'
  const scrollToValue = getQueryParam('scrollTo');

  // Create a mutation observer to check if '#shopify-product-reviews' is loaded on the page
  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.target.id === 'shopify-product-reviews') {
        // If 'scrollTo' parameter is found, scroll to the corresponding anchor
        if (scrollToValue) {
          scrollToAnchor(scrollToValue);
        }
        observer.disconnect();
      }
    });
  });

  // Start observing the document with the configured mutation observer
  observer.observe(document, { attributes: true, childList: true, subtree: true });
})